export default __webpack_public_path__ + "static/media/all-chains.e6b3c700.svg";